import { createButton } from 'react-simple-wysiwyg';

import { Italic01Icon } from '@/assets/icons/Italic01Icon';

export default createButton('Italic', <Italic01Icon />, 'italic');
